import React from 'react';
import { StrapiBulkResponseData } from 'apolloClient/types';

import NeighborhoodBlock from '../Neighborhood/NeighborhoodBlock';
import LineBetweenSections from 'components/LineBetweenSections';
import { NeighborhoodWithoutId } from 'apolloClient/types/Neighborhood';
import { getSmallImageUrlFromImage } from 'lib/getImages';
import { defaultImage } from 'src/constants/constants';
import { flattenStrapiDataItem } from 'lib/flattenStrapiBulkDataItems';
import SectionHeader from '../common/SectionHeader';
import ResponsiveCarousel from '../common/ResponsiveCarousel';

const NearbyNeighborhoods: React.FC<{
  neighborhoods: StrapiBulkResponseData<NeighborhoodWithoutId>;
}> = ({ neighborhoods }) => {
  return (
    <>
      {neighborhoods && neighborhoods.length > 0 && (
        <div className="relative container">
          <LineBetweenSections />
          <SectionHeader
            title="Nearby Neighborhoods"
            altText="Nearby Neighborhoods"
            containerClassName="pt-3 md:pt-[36px] lg:pt-[30px]"
          />
          <ResponsiveCarousel
            className="nearby-neighborhoods-carousel"
            containerClassName="relative mt-8 lg:mb-14"
            arrowHeight={{
              mobile:
                'absolute top-[50%] -translate-y-1/2 flex items-center px-3 md:px-3.5 xl:px-4 transition-colors',
              sm: 'absolute top-[50%] -translate-y-1/2 flex items-center px-3 md:px-3.5 xl:px-4 transition-colors',
              tablet:
                'absolute top-[50%] -translate-y-1/2 flex items-center px-3 md:px-3.5 xl:px-4 transition-colors',
              desktop:
                'absolute top-[50%] -translate-y-1/2 flex items-center px-3 md:px-3.5 xl:px-4 transition-colors',
              xl: 'absolute top-[50%] -translate-y-1/2 flex items-center px-3 md:px-3.5 xl:px-4 transition-colors',
            }}
          >
            {neighborhoods.slice(0, 3).map((neighbors) => (
              <NeighborhoodBlock
                key={`nearby-${neighbors.attributes?.slug}`}
                href={`/${neighbors?.attributes?.slug}`}
                imageUrl={getSmallImageUrlFromImage(
                  flattenStrapiDataItem(neighbors?.attributes?.image?.data)
                )}
                blurredImageUrl={defaultImage}
                imageAlt={`${neighbors?.attributes?.name} photo`}
                nameNeighbor={neighbors.attributes?.name}
                minSalePrice={
                  neighbors?.attributes?.neighborhoodStats?.minSalePrice || 0
                }
                maxSalePrice={
                  neighbors?.attributes?.neighborhoodStats?.maxSalePrice || 0
                }
                description={`${
                  neighbors?.attributes?.neighborhoodStats?.saleCount || 0
                } Condos for Sale`}
              />
            ))}
          </ResponsiveCarousel>
        </div>
      )}
    </>
  );
};

export default NearbyNeighborhoods;
